import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {employeePaymentRequest, qrCodePaymentResponse} from '../lib/types';
import {qrPaymentApiCall} from '../api/qrpayment.api';
//import axios from 'axios';

const qrPaymentconstData = {
  head: {
    responseTimestamp: '',
    version: '',
    clientId: '',
    signature: '',
  },
  body: {
    resultInfo: {
      resultStatus: '',
      resultCode: '',
      resultMsg: '',
    },
    qrCodeId: '',
    qrData: '',
    image: '',
  },
};

interface qrpaymentState {
  qrPaymentData: qrCodePaymentResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: qrpaymentState = {
  qrPaymentData: qrPaymentconstData,
  loading: false,
  error: '',
};

export const qrCodePayment = createAsyncThunk(
  'employee/qrpayment',
  async (parameters: employeePaymentRequest, thunkApi) => {
    return qrPaymentApiCall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const qrPaymentSlice = createSlice({
  name: 'qrPayment',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetQrPaymentState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(qrCodePayment.pending, state => {
      state.loading = true;
    });
    builder.addCase(qrCodePayment.fulfilled, (state, action) => {
      state.loading = false;
      state.qrPaymentData = action.payload;
    });
    builder.addCase(qrCodePayment.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetQrPaymentState} = qrPaymentSlice.actions;

export const qrCodeResponse = (state: RootState): qrCodePaymentResponse =>
  state.qrPaymentReducer.qrPaymentData;
export const errorInqrpayment = (state: RootState): string =>
  state.qrPaymentReducer.error;
export const qrPaymentLoading = (state: RootState): boolean =>
  state.qrPaymentReducer.loading;

export default qrPaymentSlice.reducer;
